import { memo, ReactElement, Suspense } from 'react';
import { Typography, Spin } from 'antd';
import { UserList as ListContainer } from './styles';
import Rows from './Rows';

const { Title } = Typography;

const List = memo(function List(): ReactElement {
  return (
    <ListContainer>
      <Title level={4}>ユーザー一覧</Title>
      <Suspense fallback={<Spin />}>
        <Rows />
      </Suspense>
    </ListContainer>
  );
});

export default List;
